import { Injectable } from "@angular/core";
import { ApiAction, ApiEditAction, ApiReadAction } from "../../api-actions";
import { ApiStateStoreService } from "../../api-state-store.service";
import { ApiSessionService } from "../../api-session.service";
import { sessionId } from "../../apiParams/session-id";
import { ApiGatewayUser, GatewayUser, ApiGateUsertoGatewayUser as clean } from "./gateway-user";
import { extractData, OnsipApiResponse } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { ParameterValue } from "../../util/api-action-description";
import { ApiResourceService } from "../api-resource.service";
import { arrayToRecord } from "../../util/arrayToRecord";
import { onsipApiArrayToArray } from "../../apiResponse/xml-json";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";
export { GatewayUser };

const debug = false;

@Injectable({ providedIn: "root" })
export class GatewayUserService extends ApiResourceService<GatewayUser> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "GatewayUser", "userId");

    debug && this.state.subscribe(state => console.warn("GatewayUser", state));
  }

  gatewayUserRead(
    UserId: string,
    extraParams: Record<string, ParameterValue> = {}
  ): ApiPromiseState<GatewayUser> {
    this.dispatcher.next({
      parameters: {
        Action: ApiReadAction.GatewayUserRead,
        SessionId: this.store.state.pipe(sessionId()),
        UserId,
        ...extraParams
      }
    });
    return this.promiseState.toPromise(ApiReadAction.GatewayUserRead);
  }

  gatewayUserEditCallerId(
    UserId: string,
    callerIdName?: string,
    callerIdNumber?: string,
    extraParams: Record<string, ParameterValue> = {}
  ): ApiPromiseState<GatewayUser> {
    if (callerIdName) extraParams.CallerIdName = callerIdName;
    if (callerIdNumber) extraParams.CallerIdNumber = callerIdNumber;
    this.dispatcher.next({
      parameters: {
        Action: ApiEditAction.GatewayUserEditCallerId,
        SessionId: this.store.state.pipe(sessionId()),
        UserId,
        ...extraParams
      }
    });
    return this.promiseState.toPromise(ApiEditAction.GatewayUserEditCallerId);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiReadAction.GatewayUserRead:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [clean(extractData<ApiGatewayUser>(response, action, "GatewayUser"))],
            this.indexKeyName
          ),
          action
        );
        break;

      case ApiEditAction.GatewayUserEditCallerId:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [clean(extractData<ApiGatewayUser>(response, action, "GatewayUser"))],
            this.indexKeyName
          ),
          action
        );
        break;
      case ApiAction.UserDelete:
        if (!response.Context.Request.Parameters) break;
        // eslint-disable-next-line no-case-declarations
        const deleted = onsipApiArrayToArray(response.Context.Request.Parameters, "Parameter").find(
          param => param.Name === "UserId"
        )?.Value;
        deleted && this.store.mergeStateUpdate(this.resourceName, { [deleted]: undefined }, action);
        break;
    }
  }
}
